export default "__VITE_ASSET__DuwEv1XW__"